import React, { useContext, useState, useEffect } from 'react';
import ModalContext from '../../../context/ModalContext.js';
import AuthContext from '../../../context/AuthContext.js';
import { Button, CircularProgress, TextField, Autocomplete } from '@mui/material';

const AddAdministratorModal = ({ modalDetails, onAdded }) => {
  const modalCtx = useContext(ModalContext);
  const authCtx = useContext(AuthContext);

  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [adding, setAdding] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URI}/v3/admin/administrators/users`, {
      headers: { Authorization: 'Bearer ' + authCtx.token }
    })
      .then(res => res.json())
      .then(data => {
        setUsers(data.data || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [authCtx.token]);

  const closeHandle = () => {
    modalCtx.closeModal();
  };

  const handleAdd = () => {
    if (!selectedUser) return;
    setAdding(true);
    fetch(`${process.env.REACT_APP_API_URI}/v3/admin/administrators/${selectedUser.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + authCtx.token
      },
      body: JSON.stringify({ id: selectedUser.id, access: 'admin' })
    })
      .then(res => res.json())
      .then(data => {
        setAdding(false);
        if (data.status === 'success') {
          modalCtx.setPageUpdate({ page: "Administrators" });
          if (onAdded) onAdded();
          modalCtx.closeModal();
        } else {
          alert('Failed to add administrator.');
        }
      })
      .catch(() => {
        setAdding(false);
        alert('Failed to add administrator.');
      });
  };

  return (
    <div className="modal-container">
      <div className='modal-header'>
        <h1>Add Administrator</h1>
      </div>
      <div className="modal-body">
        {loading ? (
          <CircularProgress />
        ) : (
          <Autocomplete
            value={selectedUser}
            onChange={(event, newValue) => setSelectedUser(newValue)}
            options={users}
            getOptionLabel={(option) => option ? `${option.name} (${option.email})` : ''}
            renderOption={(props, option) => (
              <li {...props} key={option.id} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span>{option.name}</span>
                <span style={{ color: '#888', fontSize: '13px' }}>({option.email})</span>
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} label="Select User" fullWidth />
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            style={{ marginBottom: '16px' }}
          />
        )}
      </div>
      <div className="modal-footer">
        <Button className="cancel-btn" onClick={closeHandle} disabled={adding}>CANCEL</Button>
        <Button onClick={handleAdd} disabled={!selectedUser || adding} variant="contained">
          {adding ? <CircularProgress size={16} style={{ color: "#fff" }} /> : ''} ADD
        </Button>
      </div>
    </div>
  );
};

export default AddAdministratorModal; 